<template>
  <ThankYouLayout class="row justify-center">
    <div v-if="loading" class="q-my-md row justify-center">
      <div class="row justify-center q-mb-lg full-width">
        <SAISpinner />
      </div>
      <p class="q-mb-md text-center text-body">
        Give us a moment to finalise the last details. Please don't close the
        window.
      </p>
    </div>
    <div v-else :style="{ maxWidth: contentMaxWidth }">
      <div class="row justify-center q-mb-lg" v-if="img">
        <img
          :src="img"
          alt="Document Signed"
          class="image-contain"
          :style="{ width: imgWidth }"
        />
      </div>
      <h6 class="q-mb-md text-application-primary text-center text-weight-bold">
        Thank you for signing the {{ documentType }} documents!
      </h6>
      <p class="text-center">
        {{ message }} Contact us on
        <SAILink
          class="text-weight-bold"
          :href="`tel:${supportNumber}`"
          target="_blank"
          :label="supportNumber"
        />
        if you have any issues.
      </p>
    </div>
  </ThankYouLayout>
</template>

<script>
import { SAILink, SAISpinner } from 'ecx.saigon.ui.common';

export default {
  name: 'DocusignThankYou',
  props: {
    loading: Boolean,
    message: String,
    documentType: String,
    supportNumber: String,
    img: String,
    imgWidth: {
      type: String,
      default: '100px'
    },
    contentMaxWidth: {
      type: String,
      default: '400px'
    }
  },
  components: {
    SAILink,
    SAISpinner,
    ThankYouLayout: () => import('../../layouts/thank-you-layout')
  }
};
</script>
